import React from 'react';
import ValidatedAutocomplete from '../ValidatedAutocomplete';
import usePrequal from '../../resources/prequal/usePrequal';
import useMerchants from '../../resources/merchant/list';

const ServiceCenterAutocomplete = ({ control, merchantId, onChange }) => {
  const { data: prequal } = usePrequal();

  const { data: serviceCenters = [], isLoading } = useMerchants({
    params: {
      location: prequal.zipCode,
      dealership_ids: [merchantId],
    },
  });

  return (
    <ValidatedAutocomplete
      name="merchantId"
      control={control}
      options={serviceCenters}
      isLoading={isLoading}
      inputLabel="Service Center"
      getOptionLabel={(o) => `${o.name} - ${o.city}, ${o.state}`}
      onChange={onChange}
    />
  );
};

export default ServiceCenterAutocomplete;
